export default __webpack_public_path__ + "static/media/text.6313397d.svg";